<template>
	<div class="content-class">
		<v-tabs color="black" dark slider-color="primary">
			<v-tab ripple>Ajouter un paramètre par défaut</v-tab>
		</v-tabs>
		<default-parameters-form v-model="document" />
	</div>
</template>

<script>
import DefaultParametersForm from '../../components/defaultParameters/defaultParameters.form'

export default {
	components: { DefaultParametersForm },
	data() {
		return {
			document: {
				schedule: {},
				messageMT: '',
				messageFV: '',
				messageMT2: '',
				messageFV2: '',
			},
		}
	},
}
</script>

<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/defaultParameters/defaultParameters.add.vue